export const COMMERCE_SEARCH_DEBOUNCE_MS = 400;

const COMMERCE_TEXT_SEARCH_FIELDS = [
    "name",
    "companyName",
    "documentNumber",
    "city",
    "cellphone",
];

const MAX_INT_DIGITS = 9;
const NUMERIC_TERM = new RegExp(`^\\d{1,${MAX_INT_DIGITS}}$`);

const sanitizeSearchTerm = (searchTerm) =>
    (searchTerm ?? "")
        .trim()
        .replace(/\s+/g, " ")
        .replace(/\*/g, "")
        .replace(/\\/g, "")
        .replace(/'/g, "\\'");

export const buildCommerceSearch = (searchTerm) => {
    const term = sanitizeSearchTerm(searchTerm);
    if (!term) {
        return "";
    }

    const criteria = COMMERCE_TEXT_SEARCH_FIELDS.map(
        (field) => `${field}:'*${term}*'`
    );
    if (NUMERIC_TERM.test(term)) {
        criteria.push(`oldId:${Number(term)}`);
    }
    return criteria.join(" OR ");
};
